<template>
  <div class="custom-tree-container">
    <div class="block">
      <el-button
        size="mini"
        type="primary"
        @click="methodAddRole"
        icon="el-icon-plus"
        >新增角色</el-button
      >

      <div class="table-style">
        <el-table
          size="mini"
          :data="RoleData"
          :header-cell-style="{ background: '#f5f7fa' }"
        >
          <el-table-column
            align="center"
            width="100"
            prop="sort"
            label="排序号"
          ></el-table-column>

          <el-table-column
            align="center"
            width="200"
            prop="name"
            label="角色名称"
          ></el-table-column>

          <el-table-column prop="remark" label="简介"></el-table-column>
          <el-table-column prop="code" label="Code"></el-table-column>

          <el-table-column label="操作" width="150" align="center">
            <template slot-scope="scope">
              <el-button size="mini" plain @click="methodEditRole(scope.row)"
                >编辑</el-button
              >
              <el-button
                size="mini"
                type="danger"
                @click="roleTypeDelete(scope.row)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination-style">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="page_no"
          :page-size="page_size"
          layout="total,prev, pager, next"
          :total="total"
        ></el-pagination>
      </div>
    </div>

    <el-drawer
      :wrapperClosable="false"
      :title="drawerTitle"
      :visible.sync="drawerVisible"
      size="50%"
    >
      <div class="drawer-container">
        <el-form ref="form" :model="form" size="mini" label-position="left">
          <el-form-item label="排序号">
            <el-input-number
              v-model="form.sort"
              :precision="1"
              :step="0.1"
              :max="10"
            ></el-input-number>
          </el-form-item>

          <el-form-item label="角色名称">
            <el-input v-model="form.name"></el-input>
          </el-form-item>

          <el-form-item label="角色简介">
            <el-input v-model="form.remark"></el-input>
          </el-form-item>
          <el-form-item label="Code">
            <el-input v-model="form.code"></el-input>
          </el-form-item>
        </el-form>
        <div class="tree">
          <span>角色权限</span>

          <el-tree
            style="margin-top: 10px"
            :data="treeData"
            show-checkbox
            node-key="id"
            default-expand-all
            :expand-on-click-node="true"
            @check-change="handleCheckChange"
            :check-strictly="false"
            ref="tree"
            :indent="40"
          >
            <div class="custom-tree-node" slot-scope="{ data }">
              <span
                :class="{ 'resource-name': data.type === 'BUTTON' }"
                @click="handleChangeLock(data)"
              >
                {{ data.name }}
                <i
                  v-if="data.type === 'BUTTON'"
                  v-show="data.lockFlag"
                  :class="{ 'icon-lock': 1 }"
                >
                  <svg
                    t="1721112035308"
                    class="icon"
                    viewBox="0 0 1024 1024"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    p-id="2492"
                    width="14"
                    height="14"
                  >
                    <path
                      d="M526.456471 30.117647a280.033882 280.033882 0 0 1 279.491764 281.840941v132.517647h36.321883c18.371765 6.686118 31.141647 24.094118 31.141647 45.056v456.041412c0 27.045647-21.082353 48.007529-48.188236 48.007529H198.776471c-27.105882 3.011765-48.188235-18.010353-48.188236-44.995764v-458.992941c0-21.082353 12.769882-38.430118 31.141647-45.116236H246.964706l0.060235-132.517647C246.964706 159.563294 367.796706 30.117647 526.456471 30.117647zM524.047059 582.535529c-42.164706 0-78.305882 36.020706-78.305883 81.016471 0 26.985412 12.047059 48.007529 30.117648 63.006118 3.011765 0 6.023529 3.011765 6.023529 6.023529v59.994353c0 63.006118 18.070588 69.029647 42.164706 69.029647 24.094118 0 42.164706-9.035294 42.164706-69.029647v-59.994353s3.011765-3.011765 6.023529-3.011765c18.070588-15.058824 33.129412-36.020706 30.117647-66.017882 0-44.995765-36.141176-81.016471-78.305882-81.016471z m-5.180235-438.151529C428.272941 144.384 345.148235 220.461176 345.148235 319.548235v124.928h352.858353l-5.421176-124.928c0-91.376941-75.474824-175.164235-173.718588-175.164235z"
                      fill="#C62928"
                      p-id="2493"
                    ></path>
                  </svg>
                </i>
              </span>
              <div class="btn-viewscope" v-if="data.viewScopes">
                <!-- v-show="checkedIds.includes(data.id)" -->
                <el-radio-group
                  v-model="data.viewScope"
                  @input="handleRadioViewScope(data)"
                >
                  <el-radio
                    v-for="scopeItem in viewScopeOptions.filter((item) =>
                      data.viewScopes.includes(item.value)
                    )"
                    :key="scopeItem.value"
                    :label="scopeItem.value"
                    >{{ scopeItem.label }}</el-radio
                  >
                </el-radio-group>
              </div>
            </div>
          </el-tree>
        </div>
        <span class="drawer-footer">
          <el-button size="small" @click="drawerVisible = false"
            >取 消</el-button
          >
          <el-button size="small" type="primary" @click="methodSubmit"
            >确 定</el-button
          >
        </span>
      </div>
    </el-drawer>
  </div>
</template>

<script>
// API
import {
  api_queryResourceTree,
  api_roleTypeQueryList,
  api_roleTypeCreate,
  api_roleTypeEdit,
  api_roleTypeDelete,
  api_roleTypeViewDetail,
} from '@/api/javaApi'
// utils
import { removeMatchingProperties } from '@/utils/utils'

export default {
  data() {
    return {
      page_no: 1,
      page_size: 10,
      total: 0,
      drawerVisible: false,
      drawerTitle: '',
      form: {
        sort: '',
        name: '',
        remark: '',
        code: null,
      },
      rowItem: null,
      defaultTreeData: [],
      treeData: [],
      RoleData: [],
      checkedIds: [],

      resourceListParams: [],
      viewScopeOptions: [
        { label: '全部数据', value: 'DEFAULT' },
        { label: '个人数据', value: 'PERSONAL' },
      ],
    }
  },

  watch: {
    drawerVisible: {
      handler(val) {
        if (!val) {
          // Object.assign(this.$data, this.$options.data())
          this.form = this.$options.data().form
          this.treeData = window.JSON.parse(
            window.JSON.stringify(this.defaultTreeData)
          )
          this.checkedIds = []
          this.resourceListParams = []
          this.rowItem = null
          // this.$refs.tree.setCheckedNodes([])
        }
      },
    },
  },
  mounted() {
    this.queryResourceTree()
    this.roleTypeQueryList()
  },

  methods: {
    //筛选权限
    handleCheckChange(nodeItem, check, childCheck) {
      console.log(nodeItem, check, childCheck)
      this.checkedIds = []
      const children = this.$refs.tree.getCheckedNodes() //返回选中子节点的key
      const parentList = this.$refs.tree.getHalfCheckedNodes() //返回选中子节点的父节点的key
      let allNodeList = children.concat(parentList)
      // console.log(allNodeList)
      this.resourceListParams = allNodeList.map((item) => {
        this.checkedIds.push(item.id)
        return Object.assign(
          {},
          {
            resourceId: item.id,
            // viewScope: item.type === 'BUTTON' ? 'DEFAULT' : null,
            viewScope: 'DEFAULT',
            lockFlag: item.lockFlag,
          }
        )
      })
      this.setTreeViewScope(this.treeData)
    },
    // 递归设置TreeViewScope
    setTreeViewScope(list) {
      if (list.length > 0) {
        list.forEach((child) => {
          if (!this.checkedIds.includes(child.id)) {
            child.viewScope = 'DEFAULT'
          }
          if (child.children) {
            this.setTreeViewScope(child.children)
          }
        })
      }
    },
    handleRadioViewScope(val) {
      if (!this.checkedIds.includes(val.id)) {
        let parentIds = []
        if (val.parentId) {
          parentIds = this.getParentIds(val.parentId)
          parentIds.push(val.id)
        }
        parentIds.forEach((item) => {
          if (!this.checkedIds.includes(item)) {
            this.checkedIds.push(item)
            this.resourceListParams.push({ resourceId: item })
            this.$refs.tree.setChecked(item, true, false)
          }
        })
      }
      this.resourceListParams.forEach((resourceItem) => {
        if (resourceItem.resourceId === val.id) {
          resourceItem.viewScope = val.viewScope
          resourceItem.lockFlag = val.lockFlag
        }
      })
    },
    // 递归查找所有父节点ID
    getParentIds(parentId) {
      const parentIds = []
      const findParents = (currentId, list) => {
        for (let i = 0; i < list.length; i++) {
          const item = list[i]

          if (item.children && item.children.length) {
            findParents(currentId, item.children) // 先递归子列表
          }

          if (item.id === currentId) {
            parentIds.push(item.id) // 找到当前节点，添加父节点ID
            if (item.parentId) {
              findParents(item.parentId, this.treeData)
            }
            return // 找到后可提前返回，优化性能
          }
        }
      }
      findParents(parentId, this.treeData)
      return parentIds.filter((id) => id !== undefined) // 过滤掉可能的undefined值
    },
    // 递归重设导航
    setChildren(list) {
      if (list.length > 0) {
        list.sort((first, last) => {
          return first.resource.sort - last.resource.sort
        })
        list.forEach((child) => {
          child.resource.viewScope = 'DEFAULT'
          if (child.resource.type === 'BUTTON') {
            child.resource.lockFlag = false
            // child.disabled = child.lockFlag
          }
          child = Object.assign(child, child.resource)
          if (child.children) {
            this.setChildren(child.children)
          }
        })
      }
      return list
    },
    //查询导航列表
    queryResourceTree() {
      api_queryResourceTree().then((res) => {
        if (res) {
          this.defaultTreeData = this.setChildren([res])
          this.treeData = window.JSON.parse(
            window.JSON.stringify(this.defaultTreeData)
          )
        }
      })
    },
    // 查询角色列表
    roleTypeQueryList() {
      api_roleTypeQueryList({
        pageNum: this.page_no,
        pageSize: this.page_size,
      }).then((res) => {
        console.log('查询角色列表')
        this.RoleData = res.content
        this.total = res.totalSize
        this.rowItem = null
      })
    },
    // 分发处理新增编辑
    methodSubmit() {
      this.resourceListParams.forEach((resourceItem) => {
        this.setViewScope(this.treeData, resourceItem, true)
      })
      if (!this.rowItem) {
        this.roleTypeCreate()
      } else {
        this.roleTypeEdit()
      }
    },
    //新增角色
    roleTypeCreate() {
      api_roleTypeCreate({
        name: this.form.name,
        sort: this.form.sort,
        remark: this.form.remark,
        code: this.form.code,
        resourceViewList: this.resourceListParams,
      }).then(() => {
        this.drawerVisible = false
        this.$message.success('创建成功')
        this.roleTypeQueryList()
      })
    },
    // 编辑角色
    roleTypeEdit() {
      const newForm = removeMatchingProperties(this.form, this.rowItem, 'id')
      console.log(newForm)
      api_roleTypeEdit({
        ...newForm,
        resourceViewList: this.resourceListParams,
      }).then((res) => {
        console.log(res)
        this.drawerVisible = false
        this.$message.success('编辑成功')
        this.roleTypeQueryList()
      })
    },
    //删除角色
    roleTypeDelete(row) {
      this.$confirm('确定删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        api_roleTypeDelete({
          id: row.id,
        }).then(() => {
          this.$message.success('删除成功')
          this.roleTypeQueryList()
        })
      })
    },
    // 递归设置viewScope
    setViewScope(list, resourceItem, reverser = false) {
      if (list.length > 0) {
        list.forEach((child) => {
          if (child.id === resourceItem.resourceId) {
            if (!reverser) {
              child.viewScope = resourceItem.viewScope
              if (child.type === 'BUTTON') {
                child.lockFlag = resourceItem.lockFlag
                child.disabled = resourceItem.lockFlag
              }
            } else {
              resourceItem.viewScope = child.viewScope
              resourceItem.lockFlag = child.lockFlag
            }
          }
          if (child.children) {
            this.setViewScope(child.children, resourceItem, reverser)
          }
        })
      }
    },
    // 查询详情
    roleTypeViewDetail(id) {
      api_roleTypeViewDetail({
        id,
      }).then((res) => {
        console.log(res)
        this.drawerVisible = true
        this.$nextTick(() => {
          // this.$refs.tree.setCheckedKeys([])
          this.checkedIds = []
          this.rowItem = res.roleType
          this.form = { ...res.roleType }
          this.resourceListParams = res.resourceViewList
          res.resourceViewList.forEach((resourceItem) => {
            this.checkedIds.push(resourceItem.resourceId)
            this.setViewScope(this.treeData, resourceItem)
            this.$refs.tree.setChecked(resourceItem.resourceId, true, false)
          })
        })
      })
    },
    //点击新增角色
    methodAddRole() {
      if (this.defaultTreeData.join('') !== '') {
        this.treeData = window.JSON.parse(
          window.JSON.stringify(this.defaultTreeData)
        )
      }
      this.$nextTick(() => {
        this.$refs.tree.setCheckedKeys([])
        this.checkedIds = []
      })
      this.drawerTitle = '新增'
      this.drawerVisible = true
    },
    //点击编辑角色
    methodEditRole(row) {
      this.drawerTitle = '编辑'
      this.roleTypeViewDetail(row.id)
    },
    handleCurrentChange(val) {
      this.page_no = val
      this.roleTypeQueryList()
    },
    handleChangeLock(data) {
      if (data.type === 'BUTTON' && this.checkedIds.includes(data.id)) {
        data.lockFlag = data.disabled = !data.lockFlag
      }
    },
  },
}
</script>

<style scoped lang="scss">
.custom-tree-container {
  margin: 10px;

  .block {
    background: #fff;
    padding: 20px;
    border-radius: 5px;

    .table-style {
      margin-top: 20px;
    }
  }
  .drawer-container {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    padding: 0 20px;
    .tree {
      flex: 1;
      display: flex;
      flex-direction: column;
      padding-bottom: 10px;
      overflow: hidden;
      .el-tree /deep/ {
        flex: 1;
        overflow: auto;
        color: #333;
        & > .el-tree-node {
          margin-bottom: 15px;
          // &.is-expanded {
          //   &::before {
          //     content: '';
          //     position: absolute;
          //     left: 30px;
          //     top: 10px;
          //     z-index: 1;
          //     height: 100%;
          //     border-left: 1px dashed #419eff;
          //   }
          // }
          & > .el-tree-node__children {
            & > .el-tree-node {
              margin-bottom: 15px;
              &.is-expanded {
                &::before {
                  content: '';
                  position: absolute;
                  left: 70px;
                  top: 10px;
                  z-index: 1;
                  height: 100%;
                  border-left: 1px dashed #419eff;
                }
              }
            }
          }
        }
        .el-tree-node {
          position: relative;
          z-index: 1;
          .el-tree-node__content {
            .el-tree-node__expand-icon:not(.is-leaf) {
              color: #419eff;
            }
          }
          // 子集
          .el-tree-node__children {
            .el-tree-node {
              .el-tree-node__content {
                // padding-left: 40px !important;
                // .expanded {
                //   position: absolute;
                //   left: 0px;
                //   &::before {
                //     content: '';
                //     display: inline-block;
                //     width: 1px;
                //     height: 13px;
                //     background-color: #419eff;
                //   }
                //   &::before {
                //     content: '';
                //     display: inline-block;
                //     width: 13px;
                //     height: 1px;
                //     background-color: #419eff;
                //   }
                // }
                .has-dashed {
                  position: relative;
                  z-index: 1;
                  &::before {
                    content: '';
                    position: absolute;
                    left: -55px;
                    top: 14px;
                    z-index: 1;
                    width: 15px;
                    border-top: 1px dashed #419eff;
                  }
                  // &::after {
                  //   content: '丅';
                  //   position: absolute;
                  //   left: -55px;
                  //   top: 14px;
                  //   z-index: 1;
                  //   width: 15px;
                  //   border-top: 1px dashed #419eff;
                  // }
                }
              }
            }
          }
        }
      }
      .custom-tree-node {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 14px;
        padding-right: 20px;
        .resource-name {
          display: inline-flex;
          align-items: center;
          transition: all 0.25s;
          cursor: pointer;
          .icon-lock {
            display: inline-flex;
            margin-left: 5px;
          }
          &:hover {
            color: #419eff;
          }
        }
      }
    }
    .drawer-footer {
      display: flex;
      justify-content: center;
      margin-bottom: 20px;
    }
  }
}
</style>
